<template lang="html">
  <div class="contract">

    <vue-pdf-viewer class="download-contract" :url="src" v-loading="loading" :height="height"></vue-pdf-viewer>
    <button type="button" name="button" class="agree" @click="ConfirmBlock = true" :disabled="btnDisable" :class="{'sl-btn-disable':btnDisable}">{{$t('Views.Contract.agree')}}</button>
    <div style="padding-bottom:60px;"><a class="contact" @click="ContactBlock = true">{{$t('Views.Contract.contact')}}</a></div>

    <div class="sl-mask-confirm" v-show="ConfirmBlock">
      <div class="sl-block">
        <p class="sl-block-title">{{$t('Views.Contract.info')}}</p>
        <p class="sl-block-cnt">{{$t('Views.Contract.cnt')}}</p>
        <div class="sl-block-btn">
          <button class="sl-block-cancel" @click="ConfirmBlock = false">{{$t('Functional.cancel')}}</button>
          <button class="sl-block-confirm" @click="confirmContract">{{$t('Functional.confirm')}}</button>
        </div>
      </div>
    </div>

    <div class="sl-mask-confirm" v-show="ContactBlock">
      <div class="sl-block-contact">
        <i class="sl-block-icon" @click="ContactBlock = false">X</i>
        <p class="sl-block-title" style="padding-bottom: 30px;">{{$t('Views.Contract.tip')}}</p>
        <p class="sl-contact-cnt">{{$t('Views.Contract.mail')}}: <strong>{{$store.state.theme.companyInfo.email}}</strong></p>
        <p class="sl-contact-cnt">{{$t('Views.Contract.phone')}}: <strong>{{$store.state.theme.companyInfo.phone}}</strong></p>
      </div>
    </div>


  </div>
</template>

<script>
import * as types from '../../store/types'
import api from '../../api'
import VuePDFViewer from 'vue-instant-pdf-viewer'
export default {
  data() {
    return {
      ConfirmBlock: false,
      ContactBlock: false,
      src: '',
      loading: false,
      btnDisable: true
    }
  },
  components: {
    'vue-pdf-viewer': VuePDFViewer
  },
  computed: {
    height() {
      return (document.documentElement.clientHeight - 200) + 'px'
    }
  },
  created() {
    const vm = this
    this.loading = true
    api.FetchContract({
      merchantId: this.$store.state.user.userinfo.merchantId,
      name: this.$store.state.theme.name
    }).then(res => {
      if (res.data.code === 200) {
        vm.src = res.data.data.contractUrl + '&type=agreement'
        this.btnDisable = false
      }
      this.loading = false
    })
  },
  methods: {
    errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      })
    },
    successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      })
    },
    confirmContract() {
      this.$ga.event('Link', 'Confirm Contract', 'Contract')
      const vm = this
      api.PostSign().then(res => {
        if (res.data.code === 200) {
          vm.$store.commit(types.ISSIGN)
          vm.successMsg(res)
          vm.$router.push({
            name: 'OB-ServiceFee'
          })
        } else {
          vm.errorMsg(res)
        }
      })
    }
  }
}
</script>

<style scoped>
.contract {
  background: #FFFFFF;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  min-width: 700px;
  margin: 20px 20px 20px 20px;
  text-align: center;
}

.title {
  font-family: Avenir-Medium;
  font-size: 32px;
  color: #4A4A4A;
  padding: 60px 0;
}

.cnt {
  font-family: Avenir-Book;
  font-size: 15px;
  color: #4A4A4A;
  line-height: 18px;
  text-align: left;
  padding: 10px 50px;
}

.agree {
  background: #64BE2C;
  border-radius: 2px;
  width: 200px;
  height: 46px;
  border: none;
  font-family: Avenir-Medium;
  font-size: 18px;
  color: #FFFFFF;
  margin: 60px 0 30px 0;
}

.contact {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #9B9B9B;
  cursor: pointer;
}

.el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.7);
}

.sl-mask-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.70);
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  overflow-y: hidden;
}

.sl-block {
  background: #FFFFFF;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  width: 380px;
  height: 312px;
  position: absolute;
  left: 50%;
  margin-left: -190px;
  top: 50%;
  margin-top: -156px;
}

.sl-block-title {
  font-family: Avenir-Book;
  font-size: 16px;
  color: #4A4A4A;
  line-height: 16px;
  padding-top: 30px;
}

.sl-block-cnt {
  font-family: Avenir-Medium;
  font-size: 18px;
  color: #4A4A4A;
  line-height: 30px;
  max-width: 280px;
  margin: 0 auto;
  padding-top: 45px;
}

.sl-block-btn {
  padding-top: 50px;
}

.sl-block-btn button {
  background: #F4F4F4;
  border-radius: 2px;
  height: 36px;
  width: 100px;
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #9B9B9B;
  border: none;
  margin: 0 10px;
}

.sl-block-btn button.sl-block-confirm {
  background: #2B90E9;
  border-radius: 2px;
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #FFFFFF;
}

.sl-block-contact {
  width: 380px;
  height: 204px;
  background: #FFFFFF;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -190px;
  margin-top: -102px;
}

.sl-contact-cnt {
  font-family: Avenir-Book;
  font-size: 14px;
  color: #9B9B9B;
  line-height: 26px;
}

.sl-contact-cnt strong {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #000000;
  line-height: 26px;
}

.sl-block-icon {
  position: absolute;
  right: 10px;
  top: 5px;
  font-family: Avenir-Book;
  font-size: 14px;
  color: #9B9B9B;
  cursor: pointer;
}

.download-contract {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.contract .sl-btn-disable {
  background-color: #d7d7d7;
}
</style>



// WEBPACK FOOTER //
// contract.vue?79d86128